import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
} from '@tabler/icons-react';

import { useUiState } from '@/hooks/useUiState';
import { NAV_ITEM_ICON_SIZE } from '@/constants/appShell';

import styles from './Sidebar.module.css';

export const SidePanelToggleButton = memo(function SidePanelToggleButton() {
  const { t } = useTranslation();
  const { isSidePanelOpen, toggleSidePanel } = useUiState();

  const Icon = isSidePanelOpen
    ? IconLayoutSidebarLeftCollapse
    : IconLayoutSidebarLeftExpand;

  return (
    <button
      type="button"
      className={styles.navItem}
      aria-label={t('appShell.sidebar.togglePanel')}
      aria-pressed={isSidePanelOpen}
      onClick={() => toggleSidePanel()}
    >
      <span className={styles.navItemIcon}>
        <Icon size={NAV_ITEM_ICON_SIZE} />
      </span>
    </button>
  );
});
